/* ============
 * State of the filters module
 * ============
 *
 * The initial state of the filters module.
 */

export default {
  filters: [],
  activeFilters: [],
};
